/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:14:11
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/lineProgress.js
 */
export default {
    // lineProgress 组件
    lineProgress: {
        activeColor: '#19be6b',
        inactiveColor: '#ececec',
        percentage: 0,
        showText: true,
        height: 12
    }
}
